/**
 * The one light per screen (decisions.md §9): it moves between offices — greeting, waiting,
 * playing, keeping watch — so a screen places this one, never a second.
 */
import classNames from 'classnames'
import styles from './PointOfLight.module.scss'

export type PointOfLightSize = 'hero' | 'session' | 'inline'

export type PointOfLightProps = {
    size?: PointOfLightSize
    breathing?: boolean
    dim?: boolean
    className?: string
}

export function PointOfLight({size = 'session', breathing = false, dim = false, className}: PointOfLightProps) {
    return (
        <span
            className={classNames(styles.light, styles[`light--${size}`], {
                [styles['light--breath']]: breathing,
                [styles['light--dim']]: dim,
            }, className)}
            aria-hidden="true"
        />
    )
}
